import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
// ** Import custom components for redux**
import { Provider } from 'react-redux';
import { persistor, store } from './store/index';
import { PersistGate } from 'redux-persist/integration/react';
import { injectStore } from './utils/api';

//Bootstrap 
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import App from './App';

const container = document.getElementById('root');
const root = createRoot(container);
injectStore(store);

root.render(
	<Provider store={store}>
		<PersistGate loading={null} persistor={persistor}>
			<BrowserRouter
			// eslint-disable-next-line no-undef
			basename={process.env.REACT_APP_BASE_URL}
			>
				<App />
			</BrowserRouter>
		</PersistGate>
	</Provider>
);

